import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import IndividualTerminalAssessmentForm from "../../components/IndividualTerminalAssessmentForm";
import TerminalMarksTable from "../../components/TerminalMarksTable";
import TerminalSummaryTable from "../../components/TerminalSummaryTable";
import StudentView from "../../components/IndividualTerminalAssessmentForm/StudentView";
import { clearIndividualTerminalAssessment } from "../../actions/IndividualTerminalAssessment.action";
import { getGradeList } from "../../actions/Grade.action";
import Layout from "../../components/shared/Layout/Layout";

const IndividualTerminalAssessmentPage = ({
  individualTerminalAssessment,
  clearIndividualTerminalAssessment,
  getGradeList,
  grades,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    getGradeList();
  }, [getGradeList]);

  const handleClearData = () => {
    clearIndividualTerminalAssessment();
  };

  return (
    <div className="bg_light">
      <Layout title="Individual Terminal Assessment">
        <IndividualTerminalAssessmentForm grades={grades} />

        {individualTerminalAssessment.assessment &&
          individualTerminalAssessment.assessment.success && (
            <div className="mt-4">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h5 style={{ fontSize: "1.2rem" }}>Assessment Results</h5>
                <div className="d-flex gap-2">
                  <ReactToPrint
                    documentTitle={`Terminal Assessment - ${
                      individualTerminalAssessment.assessment.student?.name ||
                      "Student"
                    }`}
                    content={() => ref.current}
                  >
                    <PrintContextConsumer>
                      {({ handlePrint }) => (
                        <Button
                          onClick={handlePrint}
                          variant="primary"
                          size="sm"
                          className="btn_primary"
                        >
                          Print
                        </Button>
                      )}
                    </PrintContextConsumer>
                  </ReactToPrint>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={handleClearData}
                    style={{ fontSize: "0.8rem" }}
                  >
                    Clear Results
                  </button>
                </div>
              </div>

              <div ref={ref}>
                {/* Student Information Section */}
                {individualTerminalAssessment.assessment.student && (
                  <div className="pt-4 pb-3">
                    <div className="">
                      <StudentView
                        data={individualTerminalAssessment.assessment}
                        response={individualTerminalAssessment.assessment}
                      />
                    </div>
                  </div>
                )}

                <TerminalMarksTable
                  data={individualTerminalAssessment.assessment.data}
                  term={individualTerminalAssessment.assessment.extra?.term}
                  year={individualTerminalAssessment.assessment.extra?.year}
                />

                <TerminalSummaryTable
                  summary={individualTerminalAssessment.assessment.summary}
                  student={individualTerminalAssessment.assessment.student}
                />
              </div>
            </div>
          )}

        {individualTerminalAssessment.loading && (
          <div className="text-center py-4">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading assessment data...</p>
          </div>
        )}
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  individualTerminalAssessment: state.individualTerminalAssessment,
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  clearIndividualTerminalAssessment,
  getGradeList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualTerminalAssessmentPage);
